import { api } from "./api";

export const movimentacaoProcessualService = {
  listarPorProcesso: async (
    processoId,
    pagina = 1,
    limite = 10
  ) => {
    const { data } = await api.get(
      `/movimentacaoprocessual/processo/${processoId}`,
      {
        params: {
          pagina,
          limite
        }
      }
    );

    return data;
  },

  buscarPorId: async (id) => {
    const { data } = await api.get(
      `/movimentacaoprocessual/${id}`
    );

    return data;
  }
};